// Standup history page — shows past daily standup summaries.
// Data loading is handled by TicketsStandupsMain.onCreate.

import { pageBoilerplateFetch } from '../../functions/tickets/ticketUtils.js'

export const standups = {
  extends: 'AppPage',
  metadata: { title: 'Standups / Tickets / Symbols Workspace' },
  fetch: pageBoilerplateFetch,

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  TicketsStandupsMain: {},
  TicketsDetailModal: {}
}
